/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { queryOptions as queryOptionsBuilder, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../custom-client';

import { customInstance } from '../../custom-client';
import type {
  DetailError,
  NoticeHeader,
  NoticeListParams,
  PaginatedNotice,
  StandardizedError,
} from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getNoticeListUrl = (params?: NoticeListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v2/notices?${stringifiedParams}` : '/api/v2/notices';
};

/**
 * @summary アニマルオフィス向けのお知らせ一覧を返す(公開日時の新しい順)
 */
export const noticeList = async (
  params?: NoticeListParams,
  options?: Parameters<typeof customInstance>[1],
): Promise<PaginatedNotice> => {
  return customInstance<PaginatedNotice>(getNoticeListUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getNoticeListQueryKey = (params?: NoticeListParams) => {
  return ['/api/v2/notices', ...(params ? [params] : [])] as const;
};

export const getNoticeListQueryOptions = <
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNoticeListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeList>>> = ({ signal }) =>
    noticeList(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof noticeList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NoticeListQueryResult = NonNullable<Awaited<ReturnType<typeof noticeList>>>;
export type NoticeListQueryError = ErrorType<StandardizedError | DetailError>;

export function useNoticeList<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | NoticeListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticeList>>,
          TError,
          Awaited<ReturnType<typeof noticeList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeList<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticeList>>,
          TError,
          Awaited<ReturnType<typeof noticeList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeList<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary アニマルオフィス向けのお知らせ一覧を返す(公開日時の新しい順)
 */

export function useNoticeList<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNoticeListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getNoticeListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNoticeListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeList>>> = ({ signal }) =>
    noticeList(params, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type NoticeListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof noticeList>>>;
export type NoticeListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useNoticeListSuspense<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | NoticeListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeListSuspense<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeListSuspense<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary アニマルオフィス向けのお知らせ一覧を返す(公開日時の新しい順)
 */

export function useNoticeListSuspense<
  TData = Awaited<ReturnType<typeof noticeList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: NoticeListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNoticeListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getNoticeHeaderUrl = () => {
  return '/api/v2/notices/header';
};

/**
 * @summary ヘッダーに出すアニマルオフィス向けのお知らせ(最新の数件と、NEW・重要の目印を出すか)を返す
 */
export const noticeHeader = async (options?: Parameters<typeof customInstance>[1]): Promise<NoticeHeader> => {
  return customInstance<NoticeHeader>(getNoticeHeaderUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getNoticeHeaderQueryKey = () => {
  return ['/api/v2/notices/header'] as const;
};

export const getNoticeHeaderQueryOptions = <
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNoticeHeaderQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeHeader>>> = ({ signal }) =>
    noticeHeader({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof noticeHeader>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NoticeHeaderQueryResult = NonNullable<Awaited<ReturnType<typeof noticeHeader>>>;
export type NoticeHeaderQueryError = ErrorType<StandardizedError | DetailError>;

export function useNoticeHeader<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticeHeader>>,
          TError,
          Awaited<ReturnType<typeof noticeHeader>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeHeader<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticeHeader>>,
          TError,
          Awaited<ReturnType<typeof noticeHeader>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeHeader<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary ヘッダーに出すアニマルオフィス向けのお知らせ(最新の数件と、NEW・重要の目印を出すか)を返す
 */

export function useNoticeHeader<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNoticeHeaderQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getNoticeHeaderSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNoticeHeaderQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof noticeHeader>>> = ({ signal }) =>
    noticeHeader({ signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type NoticeHeaderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof noticeHeader>>>;
export type NoticeHeaderSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function useNoticeHeaderSuspense<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeHeaderSuspense<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNoticeHeaderSuspense<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary ヘッダーに出すアニマルオフィス向けのお知らせ(最新の数件と、NEW・重要の目印を出すか)を返す
 */

export function useNoticeHeaderSuspense<
  TData = Awaited<ReturnType<typeof noticeHeader>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof noticeHeader>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getNoticeHeaderSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
